var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import { ProductQuantitySelector } from "../Product/ProductQuantitySelector";
var FilterOperator = /** @class */ (function () {
    function FilterOperator() {
    }
    return FilterOperator;
}());
var ProductContextVariable = /** @class */ (function (_super) {
    __extends(ProductContextVariable, _super);
    /** Constructor **/
    function ProductContextVariable(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this._price = 0;
        _this._priceWithTax = 0;
        _this._vat = 2000;
        _this.onSale = true;
        _this.visible = true;
        _this.quantitySelector = new ProductQuantitySelector();
        //TODO : à implémenter
        _this.activatorParameter = null;
        _this.activatorOperator = null;
        _this.activatorStatusUid = null;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        ProductContextVariable.buildFromJson(_this, obj);
        return _this;
    }
    Object.defineProperty(ProductContextVariable.prototype, "price", {
        get: function () {
            return this._price;
        },
        set: function (value) {
            if (value + '' !== '') {
                value = parseInt(value + '');
                this._price = value;
                this._priceWithTax = Math.round(this._price * (1 + (this.vat / (100 * 100))));
                console.log(this._priceWithTax);
            }
            else {
                this._price = 0;
                this._priceWithTax = 0;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductContextVariable.prototype, "priceWithTax", {
        get: function () {
            return this._priceWithTax;
        },
        set: function (value) {
            this._priceWithTax = Math.round(value);
            this._price = Math.round(this._priceWithTax / (1 + (this._vat / (100 * 100))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductContextVariable.prototype, "vat", {
        get: function () {
            return this._vat;
        },
        set: function (value) {
            this._vat = value;
            this._priceWithTax = Math.round(this._price * (1 + (this.vat / (100 * 100))));
        },
        enumerable: false,
        configurable: true
    });
    ProductContextVariable.prototype.getCurrentContext = function (date, contextVariables) {
        // Find matching context var
        for (var _i = 0, contextVariables_1 = contextVariables; _i < contextVariables_1.length; _i++) {
            var contextVariable = contextVariables_1[_i];
            if (contextVariable.uid === this.contextVariableUid && contextVariable.isCurrentContext(date)) {
                return contextVariable;
            }
        }
        return null;
    };
    /** Functions **/
    ProductContextVariable.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'quantitySelector') {
                        instance.quantitySelector = new ProductQuantitySelector(json[prop]);
                    }
                    else if (prop === 'price') {
                        instance._price = json[prop];
                    }
                    else if (prop === 'priceWithTax') {
                        instance._priceWithTax = json[prop];
                    }
                    else if (prop === 'vat') {
                        instance._vat = json[prop];
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    ProductContextVariable.prototype.exportToJson = function () {
        var contextJSON = {};
        contextJSON.contextVariableUid = this.contextVariableUid;
        contextJSON.productUid = this.productUid;
        contextJSON.price = this._price;
        contextJSON.priceWithTax = this._priceWithTax;
        contextJSON.vat = this._vat;
        contextJSON.onSale = this.onSale;
        contextJSON.visible = this.visible;
        contextJSON.establishmentUid = this.establishmentUid;
        contextJSON.creationDate = this.creationDate;
        contextJSON.quantitySelector = this.quantitySelector.exportToJson();
        return contextJSON;
    };
    ProductContextVariable.getCorrespondingProductContextVariable = function (contextVariableUid, productContextVariables) {
        for (var _i = 0, productContextVariables_1 = productContextVariables; _i < productContextVariables_1.length; _i++) {
            var productContextVariable = productContextVariables_1[_i];
            if (productContextVariable.contextVariableUid === contextVariableUid) {
                return productContextVariable;
            }
        }
        return null;
    };
    return ProductContextVariable;
}(Model));
export default ProductContextVariable;
//# sourceMappingURL=ProductContextVariable.js.map